import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ApparelCard = ({ apparel, onConsult, onViewDetails }) => {
  const formatPrice = (price) => {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    })?.format(price);
  };

  return (
    <div className="bg-card rounded-lg overflow-hidden shadow-card-hover hover:shadow-honda-glow transition-all duration-300 group">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden bg-muted">
        <Image
          src={apparel?.image}
          alt={apparel?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        {apparel?.isGenuine && (
          <div className="absolute top-3 left-3 bg-primary text-primary-foreground px-3 py-1 rounded-full flex items-center space-x-1 shadow-honda-subtle">
            <Icon name="Shield" size={14} />
            <span className="text-xs font-heading font-bold">Genuine Honda</span>
          </div>
        )}
        {apparel?.stock === 0 && (
          <div className="absolute inset-0 bg-secondary/80 flex items-center justify-center">
            <span className="text-secondary-foreground font-heading font-bold text-lg">Stok Habis</span>
          </div>
        )}
        {apparel?.isNew && (
          <div className="absolute top-3 right-3 bg-success text-success-foreground px-3 py-1 rounded-full">
            <span className="text-xs font-heading font-bold">Baru</span>
          </div>
        )}
      </div>
      <div className="p-4 md:p-5 lg:p-6">
        <div className="mb-3">
          <span className="text-xs text-muted-foreground font-medium">{apparel?.category}</span>
          <h3 className="text-base md:text-lg font-heading font-bold text-foreground mt-1 line-clamp-2">
            {apparel?.name}
          </h3>
        </div>

        <div className="mb-4">
          <p className="text-sm text-muted-foreground line-clamp-2 mb-3">
            {apparel?.description}
          </p>
          
          <div className="flex items-center space-x-2 mb-2">
            <Icon name="Package" size={16} color="var(--color-muted-foreground)" />
            <span className="text-xs text-muted-foreground">Kode: {apparel?.apparelCode}</span>
          </div>

          {apparel?.warranty && (
            <div className="flex items-center space-x-2">
              <Icon name="Award" size={16} color="var(--color-primary)" />
              <span className="text-xs text-foreground font-medium">{apparel?.warranty}</span>
            </div>
          )}
        </div>

        <div className="flex items-center justify-between mb-4 pb-4 border-b border-border">
          <div>
            <p className="text-xs text-muted-foreground mb-1">Harga</p>
            <p className="text-lg md:text-xl font-heading font-bold text-primary">
              {formatPrice(apparel?.price)}
            </p>
          </div>
        </div>

        <div className="space-y-2">
          <Button
            variant="default"
            size="default"
            fullWidth
            iconName="MessageCircle"
            iconPosition="left"
            onClick={() => onConsult(apparel)}
            disabled={apparel?.stock === 0}
          >
            Konsultasi
          </Button>
          <Button
            variant="outline"
            size="default"
            fullWidth
            iconName="Info"
            iconPosition="left"
            onClick={() => onViewDetails(apparel)}
          >
            Detail Produk
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ApparelCard;